import { State } from '@ngxs/store';

import {
  ReferralsApplicationRepo,
  ReferralsFeatureDiscoveryRepo,
  ReferralsForgotPasswordRepo,
  ReferralsLastImportRepo,
  ReferralsPortalConditionsRepo,
  ReferralsPortalConnectionRepo,
  ReferralsPortalOfferAssignmentRepo,
  ReferralsPortalProfileRepo,
  ReferralsPortalProgramRepo,
  ReferralsPortalTermsRepo,
  ReferralsQuestionsRepo,
  ReferralsRewardRepo,
} from '@recruitee/http';

export const REPOSITORIES = [
  ReferralsPortalConditionsRepo,
  ReferralsPortalOfferAssignmentRepo,
  ReferralsPortalProfileRepo,
  ReferralsPortalProgramRepo,
  ReferralsPortalTermsRepo,
  ReferralsPortalConnectionRepo,
  ReferralsRewardRepo,
  ReferralsQuestionsRepo,
  ReferralsApplicationRepo,
  ReferralsFeatureDiscoveryRepo,
  ReferralsForgotPasswordRepo,
  ReferralsLastImportRepo,
];

@State({
  name: 'repository',
  children: REPOSITORIES,
})
export class ReferralsRepository {}
